export const MuiAlert = {
  styleOverrides: {
    root: {
      '&.MuiAlert-filled': {
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        svg: {
          color: '#fff',
        },
      },

      '.MuiAlert-action': {
        paddingRight: '0',
      },
    },
  },
}
